import { combineReducers } from "redux";
import {
  SUBSIDI_ADD_ERROR,
  SUBSIDI_ADD_LOADING,
  SUBSIDI_ADD_SUCCESS,
  SUBSIDI_DELETE_ERROR,
  SUBSIDI_DELETE_LOADING,
  SUBSIDI_DELETE_SUCCESS,
  SUBSIDI_EDIT_SUCCESS,
  SUBSIDI_GET_ERROR,
  SUBSIDI_GET_LOADING,
  SUBSIDI_GET_SUCCESS,
  SUBSIDI_VIEW_ERROR,
  SUBSIDI_VIEW_LOADING,
  SUBSIDI_VIEW_SUCCESS,
} from "../actions/constant";

const subsidiAddError = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_ADD_ERROR:
      return action.subsidiAddError;
    default:
      return state;
  }
};

const subsidiAddLoading = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_ADD_LOADING:
      return action.subsidiAddLoading;
    default:
      return state;
  }
};

const subsidiAddSuccess = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_ADD_SUCCESS:
      return action.subsidiAddSuccess;
    default:
      return state;
  }
};

const subsidi = (state = [], action) => {
  switch (action.type) {
    case SUBSIDI_VIEW_SUCCESS:
      return action.subsidi;
    case SUBSIDI_ADD_SUCCESS:
      return action.subsidi;
    case SUBSIDI_GET_SUCCESS:
      return action.subsidi;
    default:
      return state;
  }
};

const subsidiGetError = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_GET_ERROR:
      return action.subsidiGetError;
    default:
      return state;
  }
};

const subsidiGetLoading = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_GET_LOADING:
      return action.subsidiGetLoading;
    default:
      return state;
  }
};

const subsidiGetSuccess = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_GET_SUCCESS:
      return action.subsidiGetSuccess;
    default:
      return state;
  }
};

const subsidiViewLoading = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_VIEW_LOADING:
      return action.subsidiViewLoading;
    default:
      return state;
  }
};

const subsidiViewError = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_VIEW_ERROR:
      return action.subsidiViewError;
    default:
      return state;
  }
};

const subsidiViewSuccess = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_VIEW_SUCCESS:
      return action.subsidiViewSuccess;
    default:
      return state;
  }
};

const subsidiEditSuccess = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_EDIT_SUCCESS:
      return action.subsidiEdit;
    default:
      return state;
  }
};

const subsidiDeleteError = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_DELETE_ERROR:
      return action.subsidiDeleteError;
    default:
      return state;
  }
};

const subsidiDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_DELETE_LOADING:
      return action.subsidiDeleteLoading;
    default:
      return state;
  }
};

const subsidiDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case SUBSIDI_DELETE_SUCCESS:
      return action.subsidiDeleteSuccess;
    default:
      return state;
  }
};

// const subsidis = (state = [], action) => {
//   switch (action.type) {
//     case SUBSIDI_VIEW_SUCCESS:
//       return action.subsidi;
//     case SUBSIDI_ADD_SUCCESS:
//       return action.subsidi;
//     default:
//       return state;
//   }
// };

const subsidiReducers = combineReducers({
  subsidiAddError,
  subsidiAddLoading,
  subsidiAddSuccess,

  subsidiGetError,
  subsidiGetLoading,
  subsidiGetSuccess,
  subsidi,

  subsidiViewError,
  subsidiViewLoading,
  subsidiViewSuccess,
  // subsidis,

  subsidiDeleteError,
  subsidiDeleteSuccess,
  subsidiDeleteLoading,
  subsidiEditSuccess,
});

export default subsidiReducers;
